module.exports = __webpack_public_path__ + "img/no_personal_list.1413ba75.png";